import getSymbolFromCurrency from "currency-symbol-map";
import React from "react";

import { IgTextField, IgTypography } from "@intelligems/ig-theme";
import { Grid, InputAdornment } from "@mui/material";
import { useConfiguration } from "@src/api/configurations/use-configuration";
import { useProgressBarContext } from "@src/features/personalizations/components/offerModifications/userInterfaces/progressBar/ProgressBarContext";

export const CartValueNumberInput = () => {
  const { unitType, cartValue, setCartValue } = useProgressBarContext();
  const storeCurrencyConfig = useConfiguration<{
    code: string;
    locale: string;
  }>("shop_currency");
  return (
    <Grid item container alignItems={"center"} spacing={3}>
      <Grid item>
        <IgTypography>
          {`Cart ${unitType === "dollar" ? "Total" : "Quantity"}`}
        </IgTypography>
      </Grid>
      <Grid item width={"120px"}>
        <IgTextField
          tooltipMessage={
            "Enter the quantity of items or a cart total to see how the progress bar will appear at checkout."
          }
          InputProps={{
            startAdornment:
              unitType === "dollar" ? (
                <InputAdornment position="start">
                  {getSymbolFromCurrency(
                    storeCurrencyConfig!.value.code || "USD"
                  )}
                </InputAdornment>
              ) : null,
            endAdornment:
              unitType === "unit" ? (
                <InputAdornment position="end">Units</InputAdornment>
              ) : null,
          }}
          value={cartValue}
          onChange={(e) => {
            const value = parseInt(e.target.value);
            setCartValue(isNaN(value) ? 0 : value);
          }}
          sx={{ borderRadius: "8px" }}
        />
      </Grid>
    </Grid>
  );
};
